function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawRising = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 905.75 785.88",
    style: style
  }, props), React.createElement("path", {
    d: "M846.55 454.04c-34.48 55-27.53 130.11-11.92 189.41 5.23 19.85 11.24 40.82 7 63-5.19 27.1-24.56 48.3-44.22 60.36-35.84 22-76.9 21.14-106.92-2.22-25.94-20.19-43.14-55.23-69.62-74.34-44.31-32-104.7-13.09-157.1 16.28-37.07 20.78-77.84 47.15-112.28 31.9-24.23-10.73-39.48-40.7-46.7-73.26-3.49-15.72-5.63-32.88-13.49-44.89-4.67-7.14-11.07-11.94-17.7-15.87-60.47-35.93-141.84-6.63-200.2-47.26-39.41-27.44-62.05-83.77-69.73-143.92s-2-124.43 5.18-187.71c5.11-45 12.11-93.12 36-129.59 25.3-38.58 65.44-55.65 100.43-51.84s65.48 25.74 91.8 52.41c32.9 33.33 62.64 75.84 105 86.77 28.87 7.44 60.32-.81 90.92-5.41 51.22-7.7 101.72-5.12 151.87-1.82 48 3.13 96.31 7 141.12 23.79 31.71 11.89 56.13 36.41 85.75 52.43 19.31 10.44 41 11.88 59 25.76 22.19 17.1 41.48 48.55 32.86 88.12-8.15 37.59-38.73 58.8-57.05 87.9z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M301.12 587.31c13.74 3.8 26.85 9.53 41.11 11.47 33.49 4.55 65.2-12.18 97.83-20 75.67-18.18 155.41 11.92 234 10.27 21.76-.46 45.9-2.78 63 8.62 5.89 3.92 10.53 9.28 17.21 12.13 13.85 5.92 33.94.16 43.76 10.34 9.49 9.84.17 25.83 7.66 36.85 7.67 11.29 31.18 15.39 28.67 28.25-1.13 5.78-7.6 9.49-11.68 14.22-9.12 10.55-5.88 25.74-13 37.36-10 16.46-36.33 19.69-57.9 16.86s-43.4-9.6-64.65-5.36c-32.66 6.52-57 37.84-90.26 34-15.56-1.81-29.71-11.49-45.28-9.72-7.55.86-14.26 4.36-21.22 7a100.26 100.26 0 0 1-64.56 1.8c-12-3.8-22.8-9.83-34.4-14.42-23-9.13-48.84-12.4-74.26-12.2-32.56.26-69 5.1-94.36-12.23-11.76-8-19.84-20.24-33.71-25.29-12.58-4.58-27-2.18-40.37.32s-27.75 5-40.39.5-21.08-19-12.59-28.15c3.08-3.31 7.73-5.3 11-8.45 6.85-6.54 5.8-17.89-2.17-23.44-4.26-3-10.18-4.53-12.81-8.64-6.95-10.84 14.92-18.63 20.42-30 2.79-5.79 1-12.38 1.78-18.6 1.39-11 11.86-20.7 24.63-22.85 11.95-2 16.65 4.61 26.45 6.34 10.39 1.84 11.42 2.07 24.74.44 24.62-3.06 47.28-4.08 71.35 2.58z",
    fill: "#635151"
  }), React.createElement("path", {
    d: "M641.37.2S550.97 90.6 602 224.75s-87.49 357.23-87.49 357.23 1.48-.22 4.24-.7c185.67-32.77 277.93-245.13 174.68-402.89C655.05 119.75 623.55 50.95 641.37.2z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M641.37 1.7S550.97 92.1 602 226.25s-87.49 357.23-87.49 357.23 1.48-.22 4.24-.7c185.68-32.74 277.93-245.13 174.69-402.89-38.39-58.65-69.89-127.45-52.07-178.19z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M641.37.2s-51 110.82 0 201.22 8.75 344.11-126.85 380.56",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M802.39 365.85s-103.16-16.43-112.56 76-198.37 105.29-198.37 105.29 1.23.84 3.54 2.36c156 102.42 305.17 65.24 282.69-70.76-8.35-50.57-7.67-101.35 24.7-112.89z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M802.39 365.85s-80.07 17.58-73.5 90.38-118.91 160.09-237.43 90.91",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M625.18 604.69H215.96V248.43c0-113 91.61-204.61 204.61-204.61 113 0 204.61 91.61 204.61 204.61z",
    fill: "#a1a1aa"
  }), React.createElement("rect", {
    x: 273.73,
    y: 280.93,
    width: 293.68,
    height: 16.85,
    rx: 5.04,
    ry: 5.04,
    opacity: 0.1
  }), React.createElement("rect", {
    x: 303.82,
    y: 315.83,
    width: 233.5,
    height: 16.85,
    rx: 5.04,
    ry: 5.04,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M213.67 627.79s24.29-165.24 9.61-224.6-18.61-118.25-18.61-118.25",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M272.49 386.45l-49.62 27.5s48.55 34.95 49.62-27.5z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M169.62 398.19l55.54 14.46s-43.54 44.78-55.54-14.46zM258.94 338.46l-43.71 27s55.9 15.01 43.71-27zM174.66 356.38l40.33 7.82s-30.22 32.48-40.33-7.82zM207.99 317.99s33.6-27.15 40.07-27.41 14 25.39-.9 33.36-39.17-5.95-39.17-5.95zM169.51 300.67s34.49 12.26 38 17.26-11.42 27.52-30.76 13.76-7.24-31.02-7.24-31.02z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 362.67,
    cy: 339.67,
    r: 12.04,
    transform: "rotate(-24.1 155.7 655.797)",
    fill: "#ffd037"
  }), React.createElement("circle", {
    cx: 340.44,
    cy: 343.03,
    r: 12.04,
    transform: "rotate(-24.1 133.456 659.154)",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M599.67 640.04s-177.1-39.58 48.2-271.26c0 0 97.14 92.06 61.5 206.5-14.33 46-60.42 74.42-107.1 65.32z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M599.67 640.04c-3.89-.87-173.29-43.51 48.24-271.28 0 0 97.14 92.06 61.5 206.5-14.33 46-60.42 74.42-107.1 65.32z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M601.99 641.37s93.54-140.92 45.88-272.59",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M714.82 642.23s-42.45-8.49-53.77-19.81-62.26-31.13-67.92-17-76.42 62.26-28.3 70.75 113.21 11.32 127.36 5.66 22.63-39.6 22.63-39.6z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M564.82 670.93c48.11 8.49 113.21 11.32 127.36 5.66 10.78-4.31 18.27-25 21.23-34.66l1.42.3s-8.49 34-22.64 39.62-79.25 2.83-127.36-5.66c-13.89-2.45-17.86-8.21-16.36-15.49 1.17 4.75 6.01 8.41 16.35 10.23z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M180.33 583.41s22.41-.69 29.16-5.5 34.47-10.55 36.14-2.84 33.67 38.35 8.38 38.56-58.78-3.94-65.52-8-8.16-22.22-8.16-22.22z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M254.46 610.94c-25.3.2-58.78-3.94-65.52-8-5.13-3.13-7.18-14.34-7.86-19.52h-.75s1.42 18.07 8.16 22.18 40.22 8.25 65.52 8c7.3-.06 9.82-2.66 9.69-6.5-1.02 2.35-3.83 3.8-9.24 3.84z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M334.77 690.38s10.45-.32 13.61-2.57 16.08-4.92 16.86-1.32 15.71 17.9 3.91 18-27.42-1.84-30.57-3.75-3.81-10.36-3.81-10.36z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M369.36 703.23c-11.8.1-27.42-1.84-30.57-3.75-2.39-1.46-3.35-6.69-3.67-9.11h-.35s.66 8.43 3.81 10.35 18.77 3.85 30.57 3.75c3.41 0 4.58-1.24 4.52-3-.48 1.06-1.8 1.73-4.31 1.76z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#535461",
    d: "M345.38 288.31l4.72-19.57h14.88l-1.1 16.54-18.5 3.03zM426.18 270.39l11.57-19.3 14.34 8.27-10.47 20.95-15.44-9.92zM498.95 315.59s12.68-9.92 24.26-2.76-12.13 20.4-12.13 20.4zM560.62 374.59l25.99 2.2-8.82 7.72-17.17-9.92zM333.28 396.36l-3.86-23.15h7.17l7.17 16.54-10.48 6.61z"
  }), React.createElement("path", {
    d: "M383.45 643.35l7.17-78.31s-1.65-16.54 0-24.81-7.17-23.15-7.17-23.15-26.46-36.37-38.58-36.92c0 0-5-19.85-13.23-24.81 0 0-19.85-18.19-14.89-32 0 0 12.68-1.65 17.09-38.59 0 0 16.54-5 23.15 7.72s-1.1 34.18-1.1 34.18l7.17 15.44s-2.76-40.8 2.21-44.66c0 0-21.5-31.42-25.91-35.84 0 0-7.17-30.32-14.89-38.59 0 0-1.1-14.33 6.62-18.74s19.85-26.46 19.85-26.46 13.23-9.92 18.74 8.82-4.41 32-4.41 32-4.41 26.46.55 28.67 24.81 29.22 24.81 29.22 5-14.89 0-25.36-5-17.09 2.21-27.57 6.03-33.08 6.03-33.08 27.57-7.72 27.57-19.85c0 0 15.44-14.89 18.19 5s-16.53 36.38-16.53 36.38 3.86 28.12-2.76 32.53c0 0 3.31 33.63 11.58 40.25 0 0 19.85-1.65 18.19-36.39 0 0 24.81-20.95 28.12-32 0 0 25.91-6.06 34.73 2.21s-18.19 30.32-18.19 30.32l-14.33 23.15-3.31 26.46s22.6-11.58 30.87-19.3c0 0 3.86-2.21 16.54 0s20.4-7.17 20.4-7.17l23.71 5.51s16 11.58 0 19.3l-41.35 1.13-22.6 31.42s-8.83 22.58-5.52 25.89 13.23 47.41-10.47 73.32l-3.31 114.67z",
    fill: "#d6d6e3"
  }), React.createElement("path", {
    d: "M330.8 619.92s17.09 10.47 9.92 14.89-10.47 6.06-16.54 3.86-8.31 4.37-8.31 4.37 23.71 1.65 26.46 7.72-4.41 11.58-4.41 11.58l16.54-7.72 7.72 7.72s2.21 7.17-8.27 6.62c0 0 9.37 6.62 32.53 0s36.94 6.62 36.94 6.62-1.1 9.92-5 10.47 12.13 1.65 14.89-5 17.09-7.72 17.09-7.72l11 9.37 7.72-8.27s23.15-6.62 27-1.65 6.62-12.13 6.62-12.13 2.21-11.58 30.32-7.72 34.18-3.31 34.18-3.31l-36.28-6.58s-9.92-5 1.1-19.85 11-27.57 11-27.57l-16.54 16.54-3.31 11-10.47 5.51s5.51-15.44 4.41-19.3.55-23.15.55-23.15l-8.27 3.86h-8.82s-7.72-6.62 0-13.23 16-36.39 16-36.39l-20.95 34.73s-4.41 13.23-10.47 10.47-19.3 14.89-16 19.85 9.37 14.33 4.41 18.74-14.33 1.1-14.33 1.1l-1.65-14.89-13.21 21.03s-13.78-9.92-6.62-14.33 9.92-14.33 6.62-13.78-9.37 2.21-13.23 2.76-17.64-5.51-8.27-9.92 8.82-14.33 9.37-16.54-15.44 5-15.44 5-2.21 21.5-.55 23.71 9.92 6.62 7.17 13.78-8.82 19.3-12.13 16-5.51-2.21-8.27-10.47-1.65-27 3.31-33.63 11.54-25.43 13.23-30.94-1.1-11-5.51-7.72-6.06 3.31-11 10.47-9.37 5-7.17-3.31-8.27-19.3-9.37-13.23-.55 30.32-.55 30.32-11-9.37-12.13-3.31 5.51 17.09-1.1 18.19-19.3-9.37-19.85-6.06-8.82-13.23-13.23-11-4.41 12.68 0 18.74 12.13 8.82 7.17 14.33-9.37-12.68-16.54-11.58.52 20.95.52 20.95zM344.03 531.15s-1.65 10.47 2.21 13.23 3.3-9.34-2.21-13.23z",
    fill: "#635151"
  }), React.createElement("path", {
    d: "M351.75 541.63l14.33 3.31s-8.27 9.37-7.17 9.92 12.68 3.86 9.37 8.27-8.82 3.31-11.58 1.65-8.82-6.06-6.62-8.82 1.67-14.33 1.67-14.33zM335.76 553.76s5.51 2.21 6.06 4.41 7.72-1.1 5.51-4.41-11.57 0-11.57 0zM330.25 558.73l-2.2 5.51h4.96l-2.76-5.51zM333.01 572.51h4.96l-4.96 2.75v-2.75zM315.87 577.46s-2.76 6.06 1.65 11 3.31-10.47 3.86-11-5.51 0-5.51 0zM460.87 584.04s-1.1 8.82 2.21 9.37 1.69-5.47-2.21-9.37zM448.23 598.41l4.41-5s9.92 4.41 9.92 5 1.1 4.41 0 6.06-2.76 5-5.51 3.31-8.82-7.17-8.82-7.17zM406.88 602.83v2.76h2.21l-2.21-2.76zM406.87 613.3v8.27s4.41 3.31 4.41 0-4.41-8.27-4.41-8.27zM411.29 606.68s1.1 12.13 2.76 12.68 0-5 0-5l.55-5zM464.77 614.96h2.76v4.41h-2.76zM444.37 584.08h3.86v7.17h-3.86z",
    fill: "#635151"
  }), React.createElement("path", {
    d: "M384.87 423.65s3.86-8.82 6.06-8.27",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M446.57 467.75s-56.46-30.35-59.65-48.25M407.43 408.76s38.59 33.63 40.8 48M409.64 398.29s16 4.41 25.36 17.09 30.87 32 35.84 32M449.87 403.25s29.22 11.58 28.12 19.3c0 0-11.58-12.13-19.85-9.92s-8.27-9.38-8.27-9.38z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M384.87 452.87s11.58 7.72 9.92 12.68-1.65 14.33-1.65 14.33",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M359.47 474.37l1.1 5.51s3.31-1.65 3.86 0 4.41 5.51 4.41 5.51l2.21-3.31z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.1,
    d: "M331.9 422.55l-13.95 14.25M329.7 436.88a16.48 16.48 0 0 1-1.65 6.62c-1.65 3.31-5.14 1.86-5.14 1.86"
  }), React.createElement("path", {
    d: "M334.66 431.37s13.78-12.68 20.95-5l3.09 6.34a23.93 23.93 0 0 0-24.04-1.34z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M397.51 333.24s10.47-2.76 14.89 0M363.87 294.64s-3.86 9.37-2.76 18.19M344.03 322.21s-4.41 7.72 3.86 20.4",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.1
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M350.1 353.09l8.82-6.07v2.76l-8.82 3.31z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.1,
    d: "M373.8 381.75l11.03-2.2M370.49 387.26s14.89-5.51 16.54-4.41 6.06-1.1 6.06-1.1M404.67 338.75s13.23-6.06 20.4 5.51M345.13 316.7s14.89-2.76 19.85 1.65M441.61 285.27s-3.86 12.68-11 18.19"
  }), React.createElement("path", {
    d: "M461.46 349.77s8.82 21.5 23.71 17.64M490.68 504.69s16.73-13.78 18-30.32",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.1,
    d: "M489.58 445.71l16.09-4.43"
  }), React.createElement("path", {
    d: "M422.32 523.44s27-8.82 27.57-43.55",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.1,
    d: "M438.31 570.3l3.3-46.86M448.23 568.1l4.96-44.66"
  }));
};

UndrawRising.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawRising;